import SimpleQuestion from "./SimpleQuestion";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField, Button, Box } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getLanguageCode } from "../store/components";
import { getQuestionDetailsFromQuestionTable } from "../store/qf"; 
import { makeStyles, withStyles } from "@material-ui/core/styles";
import * as theme from "../theme";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { useStylesLocally } from "../muithemeclasses";
import { getBrokerInformation } from "../store/broker";
import { getProspectDoc } from "../store/qf";
import { YesNoRadio } from "./YesNo"

const useStyles = makeStyles((theme) => ({
    box:{
      height:null,
    },	
    gridbutton: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '8px',
      textTransform: 'none',
      textAlign: 'left',
      minHeight: '80px',
      fontFamily:'GibsonLight',
      color: (props) => (props.isContained ? '#fff' : null),
      backgroundColor: (props) => (props.isContained ? null : 'transparent'),
      '&:hover': {
        backgroundColor: (props) => (props.isContained ? null : 'rgba(0, 0, 0, 0.04)'),
      },

      "&.MuiButton-containedPrimary": {
      backgroundColor: "rgb(63, 68, 90)",
        "&:hover": {
          backgroundColor: "rgba(63, 68, 90, 0.8)", // Slightly lighter for hover
        },
      },
      // For outlined variant: set border and text color
      "&.MuiButton-outlinedPrimary": {
        borderColor: "rgb(63, 68, 90)",
        color: "rgb(63, 68, 90)",
        "&:hover": {
          borderColor: "rgba(63, 68, 90, 0.8)",
          backgroundColor: "rgba(63, 68, 90, 0.04)", // Subtle hover effect
        },
      },
      // For disabled state (applies to both contained and outlined)
      "&.Mui-disabled": {
        // backgroundColor: "rgb(102, 102, 102) !important", // For contained
        borderColor: "rgb(102, 102, 102) !important", // For outlined
        color: "rgb(102, 102, 102) !important", // For text
      },  
    }
  }));

const BundleSet = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
  stylecss
}) => {
  let boxlist = false;
  //console.log("node.answer: ", node.answer)
  if (node?.logic?.boxlist) boxlist = true;
  let options = node?.logic?.optionlist || [];
  return (
    <div
      style={{'display':'flex', 'flexDirection': 'column', 'marginBottom':'3vh'}}
    >
    <SimpleQuestion
      node={node}
      leftString={text}
      rightComponent={
         <YesNoRadio
          node={node}
          stylecss={stylecss}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
          value={node.answer?.mainanswer}
        ></YesNoRadio>
      }
      />
      <GridOptions
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
          options={options}
      />
    </div>
  );
};

const GridOptions = ({ node, handleAnswerChange, qfusermode, options }) => {
  const languagecode = useSelector(getLanguageCode);
  let brokerInfo = useSelector(getBrokerInformation);
  const languagepreference = brokerInfo.information.languagepreference;
  const handleAnswer = (event, value) => {
    handleAnswerChange(value);
  };
  const classes = useStylesLocally();
  const selected =  node.answer?.selectedoptions ||  [];
  const handleGridButtonClick = (option) => {
    handleAnswerChange(option);
  }
  return (
     <div style={{ width: '100%' }}>
        <Box
          className={classes.box}
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gridAutoRows: 'min-content', // Adjust row height based on content
            gap: '8px',
            // maxHeight: '55vh', // Optional: limit height with scroll
            overflowY: 'hidden',
            width:'100%' // Enable scrolling if many options
          }}
        >
          {options.map((option) => (
            <GridButton 
              option={option} 
              key={option}
              selected={selected}
              languagecode={languagecode}
              handleGridButtonClick={handleGridButtonClick}
              mainAnswer={node.answer?.mainanswer}
            />
          ))}
        </Box>
      </div>
  );
};

const GridButton = ({option, selected, languagecode, handleGridButtonClick, mainAnswer }) => {
  const ProspectDetails = useSelector(getProspectDoc);
  let verticalid = ProspectDetails.answers.calculatedverticalid;
  let displayNothing = false
  const id = option && option.id != null ? option.id : option ?? '';
  const isContained = selected.includes(id) ;
  const classes = useStyles({ isContained });
  const questionDetails = useSelector(getQuestionDetailsFromQuestionTable({ questionid:id }));
  if(questionDetails.questionverticalid?.length || questionDetails.operationverticalid?.length){
    if(!questionDetails.questionverticalid.includes(verticalid) && !questionDetails.operationverticalid.includes(verticalid)) {
      displayNothing = true;
    }
  }
  if(displayNothing){
    return (<></>)
  }
  return (
    <Button
      key={option}
      variant={isContained ? 'contained' : 'outlined'}
      color="primary"
      onClick={() => handleGridButtonClick(option)}
      className={classes.gridbutton}
      disabled={ ["No", null, undefined].includes(mainAnswer) }
    >
      <div style={{ fontWeight: 'bold', textAlign: 'center', }}>{questionDetails.text[languagecode]}</div>
      {/* <div style={{ color: '#666', fontSize: '0.75rem' }}>{option.description[languagecode]}</div> */}
    </Button>
  )
} 


export default BundleSet;
